<template>
  <!-- Legacy "Understanding DIGU" layout (views/about/Sections/UnderstandingDigu.vue): title and
       story on the left, the DIGU image on the right, on the sky-blue band. No underline. -->
  <sec-section :divider="false" labelledby="about-understanding" class="about-und">
    <div class="about-und__grid">
      <div class="about-und__copy">
        <h2 id="about-understanding" class="o600 sec-h2" data-reveal>{{ und.title }}</h2>
        <p class="m500 sec-body-lg about-und__text" data-reveal>{{ und.text }}</p>
      </div>
      <figure class="about-und__media" data-reveal>
        <img :src="und.image" :alt="und.imageAlt" width="1000" height="700" loading="lazy" />
      </figure>
    </div>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import { ABOUT } from '@/content/security/about';

const und = ABOUT.understanding;
</script>

<style scoped>
.about-und {
  background: var(--sec-sky);
}

.about-und__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sec-s4);
  align-items: center;
}

.about-und__copy {
  display: flex;
  flex-direction: column;
  gap: var(--sec-s3);
  min-width: 0;
}

.about-und__text {
  color: var(--sec-ink);
}

.about-und__media {
  margin: 0;
  justify-self: center;
  width: min(100%, 520px);
}

.about-und__media img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 30px 50px -28px var(--sec-header-shadow);
}

@media only screen and (min-width: 960px) {
  .about-und__grid {
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
    gap: 4rem;
  }
  .about-und__media {
    justify-self: end;
  }
}
</style>
